export default "__VITE_ASSET__DGBx98oh__"